<template>
  <div id="homepage">
    <CeeBanner />
    <Topnav />

    <div class="container marketing-ebook">
      <div class="row">
        <div class="col-sm-12 col-lg-10 col-lg-offset-1 text-center">
          <h2 class="text-center">
            Download Perfect Pitch Guide Now!
          </h2>
          <h5 class="text-center">
            Get comprehensive guideline on how to prepare outstanding Investor
            Deck, Elevator Pitch and Competition Pitch. Use practical tips and
            make a big step toward successful fundraising!
          </h5>

          <div class="text-center">
            <img
              class="img-responsive inline-block"
              src="/static/img/ebook.png"
            />
          </div>

          <div v-if="userAuthorized" class="download">
            <button
              v-if="downloadButtonVisible"
              class="btn btn-primary btn-lg"
              @click="downloadEbook()"
            >
              Download Free Guide Now!
            </button>
            <div
              v-else
              :class="{ 'animated fadeInUp': !downloadButtonVisible }"
            >
              <h4>Thank you for subscribing!</h4>
            </div>
          </div>

          <div v-else class="newsletter is-yellow">
            <div class="row">
              <div class="col-sm-12 col-md-10 col-md-offset-1 text-center">
                <NewsletterForm
                  :disabled="!consent"
                  button-text="Download"
                  :loader-black="true"
                  @subscribed="onSubscribed($event)"
                />
              </div>
              <div v-if="!subscribed">
                <div class="checkbox">
                  <label>
                    <input v-model="consent" type="checkbox" />
                    <span
                      >I agree my personal data will be stored and processed for
                      the purposes of online communication</span
                    >
                  </label>
                </div>
                <read-more
                  class="gdpr-text"
                  more-str="read more"
                  less-str="read less"
                  :text="gdprText"
                  :max-chars="190"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <page-footer />
  </div>
</template>

<script>
import Topnav from 'Topnav.vue'
import { mapState } from 'vuex'
import http from 'services/http'
import NewsletterForm from '@/components/NewsletterForm.vue'
import CeeBanner from './CeeBanner.vue'

const RETRIEVE_PERFECT_PITCH_URL = '/startups/ebook/perfect-pitch'

export default {
  components: { CeeBanner, NewsletterForm, Topnav },
  data: () => ({
    gdprText: `Point (a) Art. 6(1) and the content of the General Data Protection Regulation are the basis for the processing of personal data provided. According to Art 13 (1) and (2) of the General Data Protection Regulation of 27 April 2016 we hereby inform that the administrator of your personal data collected via www.vestbee.com will be Vestbee Sp. z o.o, with registered office at ul. Padewska 23/7, 00-077 Warsaw, Poland, mail: office@capitalventures.pl. The personal data provided will be stored until you ask us to stop the processing. The provision of data is voluntary, but necessary for use of Vestbee platform.

    You have the right to request from the controller access to your personal data, as well as rectification or erasure of data provided or restriction of processing or to object to processing as well as the right to data portability. You also have the right to withdraw consent at any time, without affecting the lawfulness of processing based on consent before its withdrawal.

    You have the right to lodge a complaint with a Polish supervisory authority if you suppose that the processing of your personal data violates the law of the General Data Protection Regulation of 27 April 2016.`,
    consent: false,
    downloadButtonVisible: true,
    subscribed: false,
  }),
  computed: mapState({
    fetchingUser: (state) => state.user.fetchInProgress,
    userAuthorized: (state) => state.user.isAuthorized,
    user: (state) => state.user.data,
  }),
  mounted() {
    this.$store.dispatch('user/fetchNoRedirect')
  },
  methods: {
    async downloadEbook() {
      await this.downloadForEmail(this.user.email)
      this.downloadButtonVisible = false
    },
    async downloadForEmail(email) {
      const response = await http.post(RETRIEVE_PERFECT_PITCH_URL, { email })
      const url = response.data.url
      window.location = url
      this.subscribed = true
    },
    async onSubscribed({ email }) {
      await this.downloadForEmail(email)
    },
  },
}
</script>

<style scoped lang="scss">
@import '~assets/css/colors.scss';

.marketing-ebook {
  .gdpr-text {
    font-size: 15px;
    font-weight: 200;
    color: $grey90;
    width: 500px;
    margin: 0 auto;
    text-align: justify;
  }

  .checkbox {
    width: 500px;
    margin: 0 auto;
    text-align: left;
  }

  .download {
    margin-bottom: 96px;
  }
}

.newsletter {
  margin-bottom: 48px;

  .newsletter-form {
    margin-bottom: 24px;
  }
}
</style>
